var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { format } from "date-fns";
import { openAsyncWindow } from "./WindowHelpers";
export class PatientConsentUseExistingRecordsViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.patientConsentUIManager = container.patientConsentUIManager;
    }
    get lastAccessedDate() {
        var _a, _b, _c, _d;
        return format((_d = (_b = (_a = this.lastRecordsSummary) === null || _a === void 0 ? void 0 : _a.createdAt) !== null && _b !== void 0 ? _b : (_c = this.patientConsentUIManager.existingRetrieval) === null || _c === void 0 ? void 0 : _c.createdAt) !== null && _d !== void 0 ? _d : new Date(), "LLL d, yyyy");
    }
    get lastRecordsSummary() {
        return this.patientConsentUIManager.existingRecordsSummary;
    }
    async useExistingRecords() {
        this.patientConsentUIManager.updateUserChoseToUpdateRecords(false);
        await this.patientConsentUIManager.reuseExistingRecords();
        await this.confirmConsentOrGoToNextPage();
    }
    lookForUpdatedRecords() {
        this.patientConsentUIManager.updateUserChoseToUpdateRecords(true);
        this.goToNextPage();
    }
    async showUnifiedRecord(type = "pdf") {
        void openAsyncWindow(async () => {
            var _a, _b, _c, _d;
            const url = type === "raw"
                ? (_b = (await this.patientConsentUIManager.getDownloadRawDocumentsLink((_a = this.patientConsentUIManager.existingRetrieval) !== null && _a !== void 0 ? _a : undefined))) === null || _b === void 0 ? void 0 : _b.downloadLink
                : (_d = (await this.patientConsentUIManager.getDownloadPdfLink((_c = this.patientConsentUIManager.existingRetrieval) !== null && _c !== void 0 ? _c : undefined))) === null || _d === void 0 ? void 0 : _d.downloadLink;
            if (!url) {
                console.warn(`No URL available`);
                return null;
            }
            return url;
        });
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentUseExistingRecordsViewModel.prototype, "lastAccessedDate", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentUseExistingRecordsViewModel.prototype, "lastRecordsSummary", null);
